// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"Login_loginPage__21JeQ","intro":"Login_intro__1WN2H","formTitle":"Login_formTitle__1Mkw4","loginBtn":"Login_loginBtn__20ooa"};